import { Link, type LinkProps } from 'react-router'

type AppLinkProps = LinkProps & {
  preventDefault?: boolean
}

export function AppLink({ children, preventDefault, ...props }: AppLinkProps) {
  return (
    <Link
      {...props}
      {...(preventDefault && {
        onClick: (e) => {
          e.preventDefault()
          props?.onClick?.(e)
        },
      })}
    >
      {children}
    </Link>
  )
}
